import { mapState, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapState({
      operationSetting: state => state.settings.operationSetting,
      withdrawalExists: state => state.themes.withdraw.withdrawalExistingData,
      verifyCurrency: state => state.banks.verifyCurrency
    }),
    ...mapGetters({
      exchangeRates: 'themes/settings/exchangeRate'
    }),
    currencyBankMinMax() {
      return {
        deposit_max: 0,
        deposit_min: 0
      }
    },
    interDepositRule() {
      return {
        amount: [
          v => !!v || this.tr(this.FRONTEND_ERROR_CODES.amountIsRequired),
          v =>
            v?.toString()?.replace(/,/g, '') > 0 ||
            this.tr(this.FRONTEND_ERROR_CODES.amountGreaterThanZero),
          v =>
            (v && parseFloat(v?.toString()?.replace(/,/g, ''))) >=
              parseFloat(this.operationSetting?.deposit_min) ||
            `${this.tr(this.FRONTEND_ERROR_CODES.minDepositIs)} ${this.formatCurrencyJS(
              this.operationSetting.deposit_min
            )}`,
          v =>
            (v && parseFloat(v?.toString()?.replace(/,/g, ''))) <=
              parseFloat(this.operationSetting?.deposit_max) ||
            `${this.tr(this.FRONTEND_ERROR_CODES.maxDepositIs)} ${this.formatCurrencyJS(
              this.operationSetting?.deposit_max
            )}`,
          v => this.decimalRule(v) || this.tr(this.FRONTEND_ERROR_CODES.decimalIsTwoDigit)
        ],
        cryptoBankAmount: [
          v => !!v || this.tr(this.FRONTEND_ERROR_CODES.required),
          v =>
            (v && parseFloat(this.form.amount) >= parseFloat(this.bank.deposit_min)) ||
            `${this.tr(this.FRONTEND_ERROR_CODES.minDepositIs)} ${this.formatCurrencyJS(
              this.bank.deposit_min
            )}`,
          v =>
            (v && parseFloat(this.form.amount) <= parseFloat(this.bank.deposit_max)) ||
            `${this.tr(this.FRONTEND_ERROR_CODES.maxDepositIs)} ${this.formatCurrencyJS(
              this.bank.deposit_max
            )}`,
          v => this.decimalRule(v) || this.tr(this.FRONTEND_ERROR_CODES.decimalIsTwoDigit)
        ],
        cryptoAmount: [
          v => !!v || this.tr(this.FRONTEND_ERROR_CODES.required),
          v =>
            (v && parseFloat(this.form.amount) >= parseFloat(this.operationSetting.deposit_min)) ||
            `${this.tr(this.FRONTEND_ERROR_CODES.minDepositIs)} ${this.formatCurrencyJS(
              this.operationSetting.deposit_min
            )}`,
          v =>
            (v && parseFloat(this.form.amount) <= parseFloat(this.operationSetting.deposit_max)) ||
            `${this.tr(this.FRONTEND_ERROR_CODES.maxDepositIs)} ${this.formatCurrencyJS(
              this.operationSetting.deposit_max
            )}`,
          v => this.decimalRule(v) || this.tr(this.FRONTEND_ERROR_CODES.decimalIsTwoDigit)
        ]
      }
    },
    interWithdrawRule() {
      return {
        amount: [
          v => !!v || this.tr(this.FRONTEND_ERROR_CODES.amountIsRequired),
          v =>
            v?.toString()?.replace(/,/g, '') > 0 ||
            `${this.tr(this.FRONTEND_ERROR_CODES.amountGreaterThanZero)}`,
          v =>
            (v && parseFloat(v?.toString()?.replace(/,/g, ''))) <= this.playerRealtimeBalance() ||
            `${this.tr(this.FRONTEND_ERROR_CODES.balanceInsufficient)}`,
          v =>
            (v && parseFloat(v?.toString()?.replace(/,/g, ''))) >=
              parseFloat(this.operationSetting?.withdraw_min) ||
            `${this.tr(this.FRONTEND_ERROR_CODES.minimumWithdrawIs)} ${this.formatCurrencyJS(
              this.operationSetting.withdraw_min
            )}`,
          v =>
            (v && parseFloat(v?.toString()?.replace(/,/g, ''))) <=
              parseFloat(this.operationSetting?.withdraw_max) ||
            `${this.tr(this.FRONTEND_ERROR_CODES.maximumWithdrawIs)} ${this.formatCurrencyJS(
              this.operationSetting.withdraw_max
            )}`,
          v => this.decimalRule(v) || this.tr(this.FRONTEND_ERROR_CODES.decimalIsTwoDigit)
        ]
      }
    }
  },
  methods: {
    getCryptoDepositExchangeRate(fromCurrency, toCurrency) {
      const rate = this.exchangeRates?.find(el => {
        if (el.from_currency === fromCurrency && el.to_currency === toCurrency) return true
        return false
      })
      return rate?.rate
    },
    decimalRule(v) {
      if (!v) return
      // Convert number to string
      const numStr = v?.replace(/,/g, '')?.toString()
      // Find the position of the decimal point
      const decimalIndex = numStr?.indexOf('.')

      // If there's no decimal point, return false
      if (decimalIndex === -1) {
        return true
      }
      // Check the length of the part after the decimal point
      const decimalPlaces = numStr.length - decimalIndex - 1
      // Return true if exactly one decimal place, otherwise false
      return decimalPlaces >= 1 && decimalPlaces <= 2
    },
    async trackDepositEvent(sequence, amount) {
      if (sequence === 0) {
        // First deposit event
        await this.multipleTrackPixelEvent(
          this.PIXEL_EVENTS.firstDeposit,
          this.PIXEL_EVENTS.purchase,
          null,
          amount
        )
        return
      }
      if (sequence === 1) {
        // Second deposit
        // First deposit event
        await this.multipleTrackPixelEvent(
          this.PIXEL_EVENTS.redeposit,
          this.PIXEL_EVENTS.purchase,
          null,
          amount
        )
        return
      }
      await this.trackPixelEvent(this.PIXEL_EVENTS.purchase, null, null, amount, true, 'deposit')
    },
    async trackThirdPartyDepositEvent(sequence, amount) {
      if (sequence === 0) {
        // First deposit event
        await this.multipleTrackPixelEvent(
          this.PIXEL_EVENTS.firstDeposit,
          this.PIXEL_EVENTS.purchase,
          null,
          amount,
          'deposit-third-party'
        )
        return
      }
      if (sequence === 1) {
        // Second deposit
        // First deposit event
        await this.multipleTrackPixelEvent(
          this.PIXEL_EVENTS.redeposit,
          this.PIXEL_EVENTS.purchase,
          null,
          amount,
          'deposit-third-party'
        )
        return
      }
      await this.trackPixelEvent(
        this.PIXEL_EVENTS.purchase,
        null,
        null,
        amount,
        true,
        'deposit-third-party'
      )
    },
    async trackWithdrawEvent(amount) {
      if (this.withdrawalExists?.sequence === 0) {
        // First deposit event
        await this.multipleTrackPixelEvent(
          this.PIXEL_EVENTS.firstWithdrawal,
          this.PIXEL_EVENTS.withdrawal,
          null,
          amount,
          'withdraw'
        )
        return
      }
      await this.trackPixelEvent(this.PIXEL_EVENTS.withdrawal, null, null, amount, true, 'withdraw')
    }
  }
}
